import { Backdrop } from '@mui/material'
import { backdropStyles } from './BackDrop.styles'

interface BackDropProps {
  isOpen: boolean
  setIsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>
}

function BackDrop({ isOpen, setIsMenuOpen }: BackDropProps) {
  return (
    <Backdrop
      open={isOpen}
      onClick={() => setIsMenuOpen(false)}
      transitionDuration={500}
      sx={backdropStyles}
    />
  )
}

export default BackDrop
